<div class="flex justify-content-center p-0">
	<div class="p-col-12 p-md-6 p-lg-3 px-3 py-0">
		<div class="flex justify-content-center p-0">
			<div class="p-grid" id="location_info" align="center">
				<div class="p-col-12">
					<h3 class="first">{{ 'h3.packing' | translate }}</h3>
				</div>
			</div>
		</div>
		<div class="pb-0">
			<label>{{ 'h5.labelCode' | translate }}</label>
			<input type="number" minlength="1" maxlength="21" min="1"
				   [ngClass]="{focusField: inputFields[0].focus}" pInputText
				   [(ngModel)]="inputFields[0].value" [id]="inputFields[0].id"
				   inputmode="numeric" tabindex="-1"
				   (keydown)="onInsertUnit($event)"
				   (keydown.enter)="findByLabel()" (ngModelChange)="this.resetSomeFields()" >
		</div>
		<div class="pb-0">
			<label>{{ 'h5.quantity' | translate }}</label>
			<input type="number" (keydown.enter)="changePartQ()" [disabled]="!showInfo"
				   [ngClass]="{focusField: inputFields[2].focus}" tabindex="-1"
				   [(ngModel)]="inputFields[2].value" [id]="inputFields[2].id" minlength="1" maxlength="21" min="1" pInputText inputmode="numeric">
		</div>
		
		<div *ngIf="showInfo">			
			<h5>Dealer : {{this.packing.workOrderItems.customers.bkCustomerC }}</h5>
			<h5>Apelido : {{this.packing.workOrderItems.customers.customerN}}</h5>
		</div>

		<div class="pb-0">
			<label>{{ 'h5.boxCode' | translate }}</label>
			<input type="number" (keydown.enter)="checkBox()" [disabled]="!showInfo"
				   [ngClass]="{focusField: inputFields[1].focus}" tabindex="-1"
				   [(ngModel)]="inputFields[1].value" [id]="inputFields[1].id" minlength="1" maxlength="21" min="1" pInputText inputmode="numeric"
				   (keydown)="onInsertUnit($event)"
				   (ngModelChange)="labelBoxIsOk = false">
		</div>
		<div class="button_container">
			<button
				class="submit w-100" type="submit" pButton (click)="newBox()"
				[disabled]="!labelBoxIsOk" label="{{'button.createNewBox' | translate }}">
			</button>
			<button
				pButton class="bin-to-bulk-button submit w-100"
				(click)="binToBulkConfirmation()" [disabled]="!labelBoxIsOk"
				label="{{'label.binToBulk' | translate}}">
			</button>
		</div>
	</div>
</div>

<alert-custom
	*ngIf="showAlert"
	(onCloseModal)="hideErrorModal($event)"
	[msg]="errorMessage"
	[elId]="errorFocus"
	[title]="errorTitle">
</alert-custom>

<input-generic
	[inputFields] = "inputFields"
	(eventEmitter) = "executeAction($event)">
</input-generic>

<p-confirmDialog
	[style]="{width: 'auto'}"
	[closable]="false"
	[baseZIndex]="10000">
</p-confirmDialog>

<p-toast
	position="top-center"
	key="tc">
</p-toast>
